var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip as MuiToolTip } from '@mui/material';
import { useState } from 'react';
export var Tooltip = function (_a) {
  var children = _a.children,
    disableOverflowCheck = _a.disableOverflowCheck,
    props = __rest(_a, ["children", "disableOverflowCheck"]);
  var _b = useState(false),
    tooltipEnabled = _b[0],
    setTooltipEnabled = _b[1];
  var handleShouldShow = function (_a) {
    var currentTarget = _a.currentTarget;
    if (disableOverflowCheck) {
      setTooltipEnabled(true);
      return;
    }
    if (currentTarget.scrollWidth > currentTarget.clientWidth) {
      setTooltipEnabled(true);
    }
  };
  return _jsx(MuiToolTip, __assign({
    sx: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    onMouseEnter: handleShouldShow,
    onMouseLeave: function () {
      return setTooltipEnabled(false);
    },
    open: tooltipEnabled,
    "data-testid": "mui-tooltip"
  }, props, {
    children: children
  }));
};